import React, { Component } from 'react'
import ShowVideoView from './ShowVideoView.jsx'
import {withTranslation} from "react-i18next";

class Page extends Component {
    render() {
        const {t} = this.props;
        const data = t('shows', {returnObjects: true});
        const showVideos = data.map((item, key) => {
            return (
                <div className='text-uppercase'>
                    <ShowVideoView key={key} item={item} />
                </div>)
        })
        return (
            <div className='show-container'>
                <div className='show-video-block'>
                    {showVideos}
                </div>
            </div>
        );
    }
}

const Show = withTranslation()(Page);
export default Show;



// WEBPACK FOOTER //
// ./src/components/Show.jsx